// extracted by mini-css-extract-plugin
export default {"customSelectHeight":"PatientsList_customSelectHeight__tmTFL","backgroundText":"PatientsList_backgroundText__1MGsK"};